export type OwnerSpacesPageQueryArgs = {
  /** 1-based page number, as it appears in the `?page` URL query param. */
  page: number;
  pageSize: number;
  ssoId: string;
};

/**
 * Builds the `spaces-v2` owner-spaces query for one page of the "My Listings"
 * page. Shared by the initial/page-change fetch and the refetch that follows a
 * space deletion so the two can't drift apart.
 *
 * `full=true` pulls space images and `include_completion_percentage=true` the
 * per-space completion ring — both are rendered on every row, so the slim
 * `fields=summary` projection is not an option here.
 */
export const buildOwnerSpacesPageQuery = ({
  page,
  pageSize,
  ssoId,
}: OwnerSpacesPageQueryArgs): string => {
  const offset = (page - 1) * pageSize;
  return (
    `owner/${ssoId}?full=true&no_deactivated=true` +
    `&limit=${pageSize}&offset=${offset}&include_completion_percentage=true`
  );
};
